/* Evashu storefront link + alt safety layer — 2026-09-02. Visible DOM only; no hidden SEO content. */
(()=>{
  const run=()=>{
    document.querySelectorAll('a[href]').forEach(a=>{
      try{
        const u=new URL(a.getAttribute('href'),location.origin);
        if(u.origin===location.origin&&u.pathname==='/collections/all') a.setAttribute('href','/collections/all-crystals');
        if(u.origin===location.origin&&u.pathname==='/collections/crystal-gifts'){
          const label=(a.textContent||'').trim().toLowerCase();
          if(label.includes('under $25')){a.setAttribute('href','/collections/bestsellers');a.textContent='Bestsellers for gifting';}
          else if(label.includes('new beginnings')) a.setAttribute('href','/collections/crystals-for-confidence');
          else a.setAttribute('href','/blogs/crystal-guides/crystal-gift-guide');
        }
      }catch(e){}
    });
    document.querySelectorAll('img').forEach(img=>{
      if((img.getAttribute('alt')||'').trim()) return;
      let label='';
      const category=img.closest('.eih-category');
      const product=img.closest('.product-card-wrapper,.eih-product-card');
      const collection=img.closest('.collection-card-wrapper,.collection-list__item');
      const pdp=img.closest('.product__media,.product-media-container');
      if(category) label=category.querySelector('.eih-category__copy b')?.textContent||'';
      else if(product) label=product.querySelector('.card__heading,.eih-product-card__body h3')?.textContent||'';
      else if(collection) label=collection.querySelector('.card__heading')?.textContent||'';
      else if(pdp) label=document.querySelector('.product__title h1,h1')?.textContent||'';
      label=label.replace(/\s+/g,' ').trim();
      if(label) img.setAttribute('alt',label);
    });
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run,{once:true}); else run();
  document.addEventListener('shopify:section:load',run);
})();
